export default __webpack_public_path__ + "static/media/acceleration.19c425ae.svg";